import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { InfoCircled } from '../../assets/UiIcons';

const useStyles = makeStyles((theme: Theme) => ({
	root: (props: FormAnnotationProps) => ({
		display: 'inline-block',
		marginTop: theme.spacing(props.marginTop ?? 0),
		marginBottom: theme.spacing(props.marginBottom ?? 3),
	}),
	inner: {
		padding: theme.spacing(3),
		backgroundColor: theme.palette.primary.light,
		color: theme.palette.primary.main,
		display: 'flex',
		alignItems: 'flex-start',
	},
	icon: {
		flex: '0 0 20px',
		color: theme.palette.primary.main,
	},
	content: {
		flex: '1 1 auto',
		paddingLeft: theme.spacing(2),
	},
}));

interface FormAnnotationProps {
	marginTop?: number;
	marginBottom?: number;
}

export const FormAnnotation: React.FC<FormAnnotationProps> = (props) => {
	const classes = useStyles(props);

	return (
		<div className={classes.root}>
			<div className={classes.inner}>
				<InfoCircled className={classes.icon} />
				<div className={classes.content}>{props.children}</div>
			</div>
		</div>
	);
};
